import { AlertType, IClientAlert } from "models/clientAlert";

import { IClientAlertsPageTexts } from "pages/JobsPage/ClientAlertsPage/ClientAlertsPage";

export function getLabel(alertType: AlertType, texts: IClientAlertsPageTexts) {
  return alertType === AlertType.Suggestion
    ? { text: texts.suggested, className: "bg-purple-rich" }
    : { text: texts.nudged, className: "bg-green-river" };
}

export function getTitle(clientAlert: IClientAlert, texts: string) {
  return texts
    .replace("{Role name}", clientAlert.role.name)
    .replace("{Breakdown name}", clientAlert.breakdown.name);
}
